import { namedValueLabel } from '../services/incidentLookup';
/**
 * Fallback labels matching Kokomo Incidents/lookup `statuses`.
 * Prefer live lookup values when available.
 */
export const FALLBACK_STATUS_LABELS = {
    0: 'New',
    1: 'Opened',
    2: 'Active',
    3: 'Closed',
};
export function referralStatusLabel(status, statuses) {
    if (statuses?.length) {
        return namedValueLabel(statuses, status, 'Status');
    }
    return FALLBACK_STATUS_LABELS[status] ?? `Status ${status}`;
}
